
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hockey-india-league",
      function () {
        return require("private-next-pages/hockey-india-league/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hockey-india-league"])
      });
    }
  